import { render, staticRenderFns } from "./ReportsDashboard.vue?vue&type=template&id=153031fa"
import script from "./ReportsDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsDashboard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ReportsDashboard.vue?vue&type=style&index=0&id=153031fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports